import { useDataUpdater } from "@/lib/hooks/useApi";
import { useSession } from "next-auth/react";
import toast from "react-hot-toast";
import { useTranslation } from "@/hooks/translationContext";

export const useFavorites = (venueId: number) => {
    const { t } = useTranslation();
    const { data: sessionData, update } = useSession();

    const { sendRequest: addFavorite } = useDataUpdater({
        path: `favorite`,
        body: { venueId },
        method: "POST",
        auth: true,
    });

    const { sendRequest: removeFavorite } = useDataUpdater({
        path: `favorite/${venueId}`,
        body: {},
        method: "DELETE",
        auth: true,
    });

    const handleFavoriteClick = async () => {
        if (!sessionData?.user) {
            return false;
        }

        const response = await addFavorite();
        if (!response.user_id) {
            return false;
        }

        const data = {
            ...sessionData,
            user: {
                ...sessionData.user,
                likedVenues: [
                    ...(sessionData.user.likedVenues as number[]),
                    venueId,
                ],
            }
        }
        await update(data);
        toast.success(t("favorite-add-success"));
        return true;
    };

    const handleUnFavoriteClick = async () => {
        const response = await removeFavorite();
        if (!response) {
            return false;
        }

        const likedVenues = sessionData?.user?.likedVenues || [];
        const filteredLikedVenues = likedVenues.filter(
            (id: number) => id !== venueId,
        );

        const data = {
            ...sessionData,
            user: {
                ...sessionData?.user,
                likedVenues: filteredLikedVenues
            }
        }

        await update(data);
        toast.success(t("favorite-remove-success"));
        return true;
    };

    return { handleFavoriteClick, handleUnFavoriteClick };
};